import DownloadPDFIcon from './DownloadPDFIcon';

export default DownloadPDFIcon;
